<template>
    <div>
        <div class="page__bd_spacing">
            <van-field label="头像" input-align="right" style="line-height: 88px">
                <template #input>
                    <van-uploader v-model="user.photo" :after-read="afterRead" :max-count="1"/>
                </template>
            </van-field>
            <van-field v-model="user.mobile" type="tel" label="手机号" readonly />
            <van-field v-model="user.user_name" label="姓名" placeholder="请输入姓名" maxlength="50" />
            <van-field label="性别">
                <template #input>
                    <van-radio-group v-model="user.sex" direction="horizontal">
                        <van-radio name="男">男</van-radio>
                        <van-radio name="女">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field v-model="user.company" label="公司" placeholder="请输入公司" maxlength="100" />
            <van-field v-model="user.job" label="职位" placeholder="请输入职位" maxlength="50" />
        </div>
        <div class="button" @click="onSave">保存</div>
    </div>
</template>

<script>
    import { Field,RadioGroup,Radio,Uploader} from 'vant';
    export default {
        name: "info",
        components:{
            [Field.name]:Field,
            [RadioGroup.name]:RadioGroup,
            [Radio.name]:Radio,
            [Uploader.name]:Uploader
        },
        data(){
            return {
                user: {
                    sex:'男'
                },
                domain:'',
                default_head:require('../../assets/icon/default_head.png')
            }
        },
        mounted() {
            this.util.hideOptionMenu();
            this.onLoad();
        },
        methods:{
            onLoad(){
                this.user = this.util.globalData.user.get();
                this.user.photo = [
                    {
                        url:this.user.photo || this.default_head,
                        isImage: true
                    }
                ]
            },
            onSave(){
                var _self=this;
                var params = JSON.parse(JSON.stringify(this.user));

                if(params.photo.length == 0 || params.photo[0].url == ''){
                    return this.util.showToast({
                        message: '请设置头像',
                    });
                }
                params.photo = params.photo[0].url;
                params.photo = params.photo.replace(this.domain,'');

                if (this.util.trim(params.user_name).length < 1) {
                    return this.util.showToast({
                        message: '请输入姓名',
                    });
                }

                if (this.util.trim(params.sex).length == 0) {
                    return this.util.showToast({
                        message: '请选择性别',
                    });
                }

                if (this.util.trim(params.company).length < 2) {
                    return this.util.showToast({
                        message: '请输入公司',
                    });
                }

                if (this.util.trim(params.job).length < 2) {
                    return this.util.showToast({
                        message: '请输入职位',
                    });
                }
                // TODO storage中 token为当前登录sessionID, 与机构token不一致
                params.token = this.util.token
                this.util.server.mini_user.save({
                    data: params,
                    callback: res => {
                        if(res.code == -1){
                            return this.util.showToast({
                                message: res.msg,
                            });
                        }
                        _self.util.globalData.user.set(params);

                        this.$router.go(-1);
                    }
                })

            },
            afterRead(file) {
                var _self=this;
                file.status = 'uploading';
                file.message = '上传中...';
                // 此时可以自行将文件上传至服务器
                this.util.upfile({
                    file: file.file,
                    callback: res => {
                        if(res.code == -1){
                            file.status = 'failed';
                            file.message = '上传失败';
                        }
                        file.status = 'done';
                        file.message = '上传成功';

                        _self.user.photo = [
                            {
                                url:res.data.domain+'/'+res.data.name,
                                isImage: true
                            }
                        ];
                        _self.domain=res.data.domain
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .head {
        width: 60px;
        height: 60px;
        margin-right: 15px;
        background-color: #327ce9;
        border-radius: 50%;
        overflow: hidden;
        float: right;
    }

    img {
        width: 100%;
        height: 100%;
    }
    .bd_phone{
        color: #fff;
        padding: 3px 5px;
        background-color: #327ce9;
        border-radius: 5px;
        font-size: 12px;
    }
</style>
